export default class Device {
  DID: number;
  GROUPID: number;
  NAME: string;
  IDENTIFIER: string;
  INTERVALL: number;
  CONNECTPATH: string;
  APPVERSION: string;
  APPVERSIONSM: string;
  TARGETVERSION: string;
  TARGETVERSIONSM: string;
  REPORTING: boolean | null;
  CPU: number;
  RAM: number;
  NETWORK: string;
  HEARTBEAT: string;
  IP: string;
  MASTER: string;
  plugIp: string;
  FORCEREBOOT: string;
  DAYLIEREBOOT: string;
  LASTAPPSTART: string;
  ACTIVATIONKEY: string;
  ACTIVATED: string;
  ORIENTATION: string;
  useSentry: boolean;
  useFaceRecognition: boolean;
  useNFCReader: boolean;
  useBarcodeScanner: boolean;
  useP2P: boolean;
  checkForKnownWIFIs: boolean;
  useUUID: boolean;
  useSelfie: boolean;
  useDeviceControl: boolean;
  useWebSocket: boolean;
  deleteUnusedFiles: boolean;
  notifiedDueToInactive: boolean;
  isSyncMaster: string;
  firebaseToken: string;
  preBarcodeAnimation: string;
  playlistHeredity: string;

  constructor(
    DID: number,
    GROUPID: number,
    NAME: string,
    IDENTIFIER: string,
    INTERVALL: number,
    CONNECTPATH: string,
    APPVERSION: string,
    APPVERSIONSM: string,
    TARGETVERSION: string,
    TARGETVERSIONSM: string,
    REPORTING: boolean | null,
    CPU: number,
    RAM: number,
    NETWORK: string,
    HEARTBEAT: string,
    IP: string,
    MASTER: string,
    plugIp: string,
    FORCEREBOOT: string,
    DAYLIEREBOOT: string,
    LASTAPPSTART: string,
    ACTIVATIONKEY: string,
    ACTIVATED: string,
    ORIENTATION: string,
    useSentry: boolean,
    useFaceRecognition: boolean,
    useNFCReader: boolean,
    useBarcodeScanner: boolean,
    useP2P: boolean,
    checkForKnownWIFIs: boolean,
    useUUID: boolean,
    useSelfie: boolean,
    useDeviceControl: boolean,
    useWebSocket: boolean,
    deleteUnusedFiles: boolean,
    notifiedDueToInactive: boolean,
    isSyncMaster: string,
    firebaseToken: string,
    preBarcodeAnimation: string,
    playlistHeredity: string,
  ) {
    this.DID = DID;
    this.GROUPID = GROUPID;
    this.NAME = NAME;
    this.IDENTIFIER = IDENTIFIER;
    this.INTERVALL = INTERVALL;
    this.CONNECTPATH = CONNECTPATH;
    this.APPVERSION = APPVERSION;
    this.APPVERSIONSM = APPVERSIONSM;
    this.TARGETVERSION = TARGETVERSION;
    this.TARGETVERSIONSM = TARGETVERSIONSM;
    this.REPORTING = REPORTING;
    this.CPU = CPU;
    this.RAM = RAM;
    this.NETWORK = NETWORK;
    this.HEARTBEAT = HEARTBEAT;
    this.IP = IP;
    this.MASTER = MASTER;
    this.plugIp = plugIp;
    this.FORCEREBOOT = FORCEREBOOT;
    this.DAYLIEREBOOT = DAYLIEREBOOT;
    this.LASTAPPSTART = LASTAPPSTART;
    this.ACTIVATIONKEY = ACTIVATIONKEY;
    this.ACTIVATED = ACTIVATED;
    this.ORIENTATION = ORIENTATION;
    this.useSentry = useSentry;
    this.useFaceRecognition = useFaceRecognition;
    this.useNFCReader = useNFCReader;
    this.useBarcodeScanner = useBarcodeScanner;
    this.useP2P = useP2P;
    this.checkForKnownWIFIs = checkForKnownWIFIs;
    this.useUUID = useUUID;
    this.useSelfie = useSelfie;
    this.useDeviceControl = useDeviceControl;
    this.useWebSocket = useWebSocket;
    this.deleteUnusedFiles = deleteUnusedFiles;
    this.notifiedDueToInactive = notifiedDueToInactive;
    this.isSyncMaster = isSyncMaster;
    this.firebaseToken = firebaseToken;
    this.preBarcodeAnimation = preBarcodeAnimation;
    this.playlistHeredity = playlistHeredity;
  }

  static fromObject(obj: {
    DID: number;
    GROUPID: number;
    NAME: string;
    IDENTIFIER: string;
    INTERVALL: number;
    CONNECTPATH: string;
    APPVERSION: string;
    APPVERSIONSM: string;
    TARGETVERSION: string;
    TARGETVERSIONSM: string;
    REPORTING: boolean | null;
    CPU: number;
    RAM: number;
    NETWORK: string;
    HEARTBEAT: string;
    IP: string;
    MASTER: string;
    plugIp: string;
    FORCEREBOOT: string;
    DAYLIEREBOOT: string;
    LASTAPPSTART: string;
    ACTIVATIONKEY: string;
    ACTIVATED: string;
    ORIENTATION: string;
    useSentry: boolean;
    useFaceRecognition: boolean;
    useNFCReader: boolean;
    useBarcodeScanner: boolean;
    useP2P: boolean;
    checkForKnownWIFIs: boolean;
    useUUID: boolean;
    useSelfie: boolean;
    useWebSocket: boolean;
    useDeviceControl: boolean;
    deleteUnusedFiles: boolean;
    notifiedDueToInactive: boolean;
    isSyncMaster: string;
    firebaseToken: string;
    preBarcodeAnimation: string;
    playlistHeredity: string;
  }) {
    return new Device(
      obj.DID,
      obj.GROUPID,
      obj.NAME,
      obj.IDENTIFIER,
      obj.INTERVALL,
      obj.CONNECTPATH,
      obj.APPVERSION,
      obj.APPVERSIONSM,
      obj.TARGETVERSION,
      obj.TARGETVERSIONSM,
      obj.REPORTING,
      obj.CPU,
      obj.RAM,
      obj.NETWORK,
      obj.HEARTBEAT,
      obj.IP,
      obj.MASTER,
      obj.plugIp,
      obj.FORCEREBOOT,
      obj.DAYLIEREBOOT,
      obj.LASTAPPSTART,
      obj.ACTIVATIONKEY,
      obj.ACTIVATED,
      obj.ORIENTATION,
      obj.useSentry,
      obj.useFaceRecognition,
      obj.useNFCReader,
      obj.useBarcodeScanner,
      obj.useP2P,
      obj.checkForKnownWIFIs,
      obj.useUUID,
      obj.useSelfie,
      obj.useDeviceControl,
      obj.useWebSocket,
      obj.deleteUnusedFiles,
      obj.notifiedDueToInactive,
      obj.isSyncMaster,
      obj.firebaseToken,
      obj.preBarcodeAnimation,
      obj.playlistHeredity,
    );
  }

  toDeviceSettingsObject() {
    return {
      id: this.IDENTIFIER,
      useSentry: +this.useSentry,
      useFaceRecognition: +this.useFaceRecognition,
      useNFCReader: +this.useNFCReader,
      useBarcodeScanner: +this.useBarcodeScanner,
      useP2P: +this.useP2P,
      checkForKnownWIFIs: +this.checkForKnownWIFIs,
      useUUID: +this.useUUID,
      useSelfie: +this.useSelfie,
      useDeviceControl: +this.useDeviceControl,
      deleteUnusedFiles: +this.deleteUnusedFiles,
      reporting: this.REPORTING === null ? null : +this.REPORTING,
      orientation: this.ORIENTATION,
      master: this.MASTER,
      syncMaster: +this.isSyncMaster,
      useWebSocket: +this.useWebSocket,
      playlistHeredity: +this.playlistHeredity,
    };
  }

  updateDeviceSettings(obj: {
    useSentry: boolean;
    useFaceRecognition: boolean;
    useNFCReader: boolean;
    useBarcodeScanner: boolean;
    useP2P: boolean;
    checkForKnownWIFIs: boolean;
    useUUID: boolean;
    useSelfie: boolean;
    useWebSocket: boolean;
    useDeviceControl: boolean;
    deleteUnusedFiles: boolean;
    notifiedDueToInactive: boolean;
    isSyncMaster: string;
    firebaseToken: string;
    master: string;
    reporting: boolean | null;
    orientation: string;
  }) {
    this.useSentry = obj.useSentry;
    this.useFaceRecognition = obj.useFaceRecognition;
    this.useNFCReader = obj.useNFCReader;
    this.useBarcodeScanner = obj.useBarcodeScanner;
    this.useP2P = obj.useP2P;
    this.checkForKnownWIFIs = obj.checkForKnownWIFIs;
    this.useUUID = obj.useUUID;
    this.useSelfie = obj.useSelfie;
    this.useWebSocket = obj.useWebSocket;
    this.useDeviceControl = obj.useDeviceControl;
    this.deleteUnusedFiles = obj.deleteUnusedFiles;
    this.notifiedDueToInactive = obj.notifiedDueToInactive;
    this.isSyncMaster = obj.isSyncMaster;
    this.firebaseToken = obj.firebaseToken;
    this.MASTER = obj.master;
    this.REPORTING = obj.reporting;
    this.ORIENTATION = obj.orientation;
  }

  toObject() {
    return {
      DID: this.DID,
      GROUPID: this.GROUPID,
      NAME: this.NAME,
      IDENTIFIER: this.IDENTIFIER,
      INTERVALL: this.INTERVALL,
      CONNECTPATH: this.CONNECTPATH,
      APPVERSION: this.APPVERSION,
      APPVERSIONSM: this.APPVERSIONSM,
      TARGETVERSION: this.TARGETVERSION,
      TARGETVERSIONSM: this.TARGETVERSIONSM,
      REPORTING: this.REPORTING,
      CPU: this.CPU,
      RAM: this.RAM,
      NETWORK: this.NETWORK,
      HEARTBEAT: this.HEARTBEAT,
      IP: this.IP,
      MASTER: this.MASTER,
      plugIp: this.plugIp,
      FORCEREBOOT: this.FORCEREBOOT,
      DAYLIEREBOOT: this.DAYLIEREBOOT,
      LASTAPPSTART: this.LASTAPPSTART,
      ACTIVATIONKEY: this.ACTIVATIONKEY,
      ACTIVATED: this.ACTIVATED,
      ORIENTATION: this.ORIENTATION,
      useSentry: this.useSentry,
      useFaceRecognition: this.useFaceRecognition,
      useNFCReader: this.useNFCReader,
      useBarcodeScanner: this.useBarcodeScanner,
      useP2P: this.useP2P,
      checkForKnownWIFIs: this.checkForKnownWIFIs,
      useUUID: this.useUUID,
      useSelfie: this.useSelfie,
      useDeviceControl: this.useDeviceControl,
      useWebSocket: this.useWebSocket,
      deleteUnusedFiles: this.deleteUnusedFiles,
      notifiedDueToInactive: this.notifiedDueToInactive,
      isSyncMaster: this.isSyncMaster,
      firebaseToken: this.firebaseToken,
      playlistHeredity: this.playlistHeredity
    };
  }
}
